import Pagination from '../Pagination';

export function NotificationPagination({ page, totalPages, total, pageSize, onChange, onPageSizeChange, disabled }: {
  page: number;
  totalPages: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
  onPageSizeChange: (pageSize: number) => void;
  disabled?: boolean;
}) {
  return <Pagination className="notice-pagination" page={page} totalPages={totalPages} onChange={onChange} total={`共 ${total} 条`} pageSize={pageSize} pageSizeOptions={[10, 20, 50, 100]} onPageSizeChange={onPageSizeChange} disabled={disabled} />;
}
